/**
 * Maps the `ReferenceID` of a `GDIRewardTileBlock` with `Type === "Earn
 * Actions"` to the customer / loyalty-data check that determines whether
 * the customer has already completed that earning action.
 *
 * Returns `false` for unknown `referenceID` values, missing customer, or
 * non-registered customers — those tiles should render in their default
 * (not-completed) state. Returns `null` when the answer is not yet known
 * (e.g. loyalty data still loading for the leave-review check) so callers
 * can choose to hide the badge until the result is final.
 */

const isPositiveCount = (value) => Number(value) > 0

const isLeaveReviewCompleted = (loyaltyData) => {
    const record = loyaltyData?.loyaltyMemberRecord
    if (!record) return null
    const max = record.Maximum_Reviews_per_Period__c ?? record.maximum_Reviews_per_Period__c
    return max != null && Number(max) > 0
}

export const REWARD_TYPE_EARN_ACTIONS = 'Earn Actions'

export const computeEarnActionCompleted = ({referenceID, customer, loyaltyData}) => {
    if (!customer?.isRegistered) return false
    switch (referenceID) {
        case 'start_shopping':
            return Boolean(
                isPositiveCount(customer?.c_sfscOnlineOrdersCount) ||
                    isPositiveCount(customer?.c_sfscInStoreOrdersCount)
            )
        case 'shop_online_store':
            return (
                isPositiveCount(customer?.c_sfscOnlineOrdersCount) &&
                isPositiveCount(customer?.c_sfscInStoreOrdersCount)
            )
        case 'subscribe_newsletter':
            return Boolean(customer?.c_email_garage_optedIn)
        case 'subscribe_sms':
            return Boolean(customer?.c_sms_garage_optedIn)
        case 'leave_review':
            return isLeaveReviewCompleted(loyaltyData)
        case 'getapp':
        case 'get_notifications':
            // Historical switch hard-coded these as not-yet-trackable.
            return false
        default:
            return false
    }
}
